import React from "react";
import Markdown from "react-markdown";

export default function SamplingFrame({
  sampling_frame_desc,
  sampling_frame_types,
}: {
  sampling_frame_desc?: string;
  sampling_frame_types?: string;
}) {
  let samplingFrameTypes: Record<string, string> | undefined;
  try {
    if (sampling_frame_types) {
      samplingFrameTypes = JSON.parse(sampling_frame_types);
    }
  } catch (error) {
    console.error("Failed to parse sampling_frame_types:", error);
  }

  return (
    <div className="tab-pane fade show active">
      {sampling_frame_desc && (
        <div className="g2-text-grey">
          <Markdown>{sampling_frame_desc}</Markdown>
        </div>
      )}
      {samplingFrameTypes && (
        <table className="table table-hover table-striped" width="100%">
          <tbody>
            {Object.entries(samplingFrameTypes).map(([field, value], index) => (
              <tr key={index}>
                <td width="50%" className="fw-bold text-end">
                  {field}
                </td>
                <td width="50%">{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
